export var LEFT_AXES_VIEW = 'left-axes-view';
export var RIGHT_AXES_VIEW = 'right-axes-view';